import React, { FC } from "react";
import { ToastContainer } from "react-toastify";

import { HomePage } from "./pages/home";

import "./App.scss";

export const App: FC = () => {
  return (
    <>
      <div className="App">
        <HomePage />
      </div>
      <ToastContainer />
    </>
  );
};
